import axios, { AxiosInstance } from "axios";
import { RefreshToken } from "services/refreshToken";
import { isAccessTokenExpired, isTokenExpired } from "utils/jwt";

const BaseUrl = process.env.REACT_APP_BASE_URL;

const getToken = async () => {
  if (isAccessTokenExpired() && !isTokenExpired()) {
    await RefreshToken();
    getToken();
  } else if (isTokenExpired()) {
    return null;
  } else {
    return localStorage.getItem("accessToken");
  }
};
const api: AxiosInstance = axios.create({
  baseURL: BaseUrl,
  headers: {
    "Content-Type": "application/json"
  }
});

// Interceptor to add Bearer token to the headers

api.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
